import React from "react"

const Loading = (props) => {
	if (props.error) {
		let chunkFailed = false
		try {
			chunkFailed = sessionStorage.getItem("chunk_retry_attempt")
			if (!chunkFailed) {
				sessionStorage.setItem("chunk_retry_attempt", "true")
			}
		} catch (e) {
			// Storage access failed (e.g. strict private mode)
		}

		if (!chunkFailed) {
			window.location.reload()
			return (
				<div className="w-100 text-center py-5">
					New content is available. Updating...
				</div>
			)
		}

		return (
			<div className="w-100 text-center py-5">
				An error occurred while loading content. <br />
				<button
					className="btn mt-4"
					onClick={() => {
						try {
							sessionStorage.removeItem("chunk_retry_attempt")
						} catch (e) {}
						window.location.reload()
					}}>
					Retry
				</button>
			</div>
		)
	}

	try {
		sessionStorage.removeItem("chunk_retry_attempt")
	} catch (e) {}

	if (props.timedOut) {
		return (
			<div className="w-100 text-center py-5">
				Taking a long time...
				<br />
				<button className="btn mt-4" onClick={() => window.location.reload()}>
					Retry
				</button>
			</div>
		)
	} else if (props.pastDelay) {
		return <div className="w-100 text-center py-5">Loading...</div>
	} else {
		return null
	}
}
export default Loading



// WEBPACK FOOTER //
// ./src/views/components/shared/Loading.js